import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDrawer } from "../Drawer/DrawerContext";
import ConfirmOrder from "../Widgets/ConfirmOrder/ConfirmOrder";

/**Listens for the history api to update with the order id */
export function useOrderConfirm(openSettings: () => void) {
  const history = useHistory<any>();
  const { openDrawer, closeDrawer } = useDrawer()!;
  useEffect(() => {
    if (history.location.state?.orderId) {
      openPaymentDrawer(
        openDrawer,
        closeDrawer,
        openSettings,
        history.location.state
      );
      history.replace({
        pathname: history.location.pathname,
        state: {
          OrderType: history.location.state?.OrderType,
          TimeSlot: history.location.state?.TimeSlot,
        },
      });
    }
    //eslint-disable-next-line
  }, [history]);
}

function openPaymentDrawer(
  openDrawer,
  closeDrawer,
  openSettingsPage,
  locationState
) {
  if (openDrawer) {
    openDrawer(
      ConfirmOrder,
      {
        TimeSlot: locationState?.TimeSlot,
        OrderType: locationState?.OrderType,
        CloseDrawer: closeDrawer,
        orderId: locationState.orderId,
        deliveryAddress: locationState?.deliveryAddress,
        tableArea: locationState?.tableArea,
        shareOnConfirmOrderPage: true,
        openSettingsPage: () => {
          closeDrawer();
          openSettingsPage(1);
        },
      },
      "bottom",
      "PaymentsConfirmOrder"
    );
  }
}
